import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';

export function HOOK_GENERATION__notifier(component_type: string) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const component_id = `${component_type}_${generation_current._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_GENERATION);

  return { notifier };
}
